import { DashboardModal } from '@uppy/react'
import { Text } from 'app/components/ui/Text'
import { theme } from 'app/styles/themeEstra'
import styled from 'styled-components'

import { getUrlWithFormat } from './utils'

export const Multiupload = styled.div`
  grid-area: Multiupload;
  display: grid;
  grid-template-columns: 1fr;
  flex-direction: column;
`
export const UploadBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: auto;
  margin-bottom: 3rem;
  @media only screen and (min-width: 820px) {
    button {
      max-width: 235px;
    }
  }
`
export const CustomDashboardModal = styled(DashboardModal)`
  font-family: 'Source Sans Pro', sans-serif;

  .uppy-Dashboard-AddFiles {
    border: none !important;
  }

  .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
    background-color: #0e1a2f !important;
    border-radius: 20px;
    font-weight: bold;
    letter-spacing: 0.3px;
  }

  @media only screen and (min-width: 820px) {
    .uppy-DashboardContent-bar {
      height: 60px !important;
    }

    .uppy-StatusBar.is-waiting .uppy-StatusBar-actions {
      position: relative;
      left: 0;
    }

    .uppy-StatusBar.is-waiting .uppy-StatusBar-actionBtn--upload {
      background-color: #0e1a2f !important;
      position: absolute;
      right: 16px;
      border-radius: 20px;
      font-weight: bold;
      letter-spacing: 0.3px;
    }

    .uppy-Dashboard-innerWrap::after {
      content: 'Carica i giustificativi';
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding: 24px 24px 15px 24px;
      border-bottom: #ededed 2px solid;
      color: #0e1a2f;
      font-family: 'PT Serif';
      font-size: 18px;
      font-weight: bold;
    }

    [dir='ltr'] .uppy-Dashboard-close {
      right: 16px;
      top: 8px;
      color: #7f8fa4;
    }

    [dir='ltr'] .uppy-size--md .uppy-DashboardContent-addMore {
      margin-right: 30px;
    }

    [data-uppy-num-acquirers='0'] .uppy-Dashboard-AddFiles-title {
      font-size: 16px;
    }
  }
`

// Styled components for Proof elements
export const ProofWrapper = styled.div`
  display: grid;
  margin-top: 1rem;
  grid-template-columns: 1fr;
  gap: 0 2rem;
  width: 100%;
  @media screen and (min-width: ${theme.bp.desktop}) {
    grid-template-columns: 1fr 1fr;
  }
`

export const Proof = styled.div`
  display: grid;
  gap: 6px;
  grid-template-columns: 52px 2fr 1.5fr 0.5fr;
  align-items: center;
  width: 100%;
  padding: 15px 0px;
  border-bottom: 2px solid #ededed;
  @media only screen and (min-width: 820px) {
    gap: 16px;
    padding: 15px 10px;
  }
`

export const ProofName = styled.div`
  display: flex;
  flex-direction: column;
`

export const ProofDate = styled.div`
  text-align: right;
`

// ProofImage component with optional src and type props
type ProofImageProps = {
  src?: string
  type?: string
}

export const ProofImage = styled.div<ProofImageProps>`
  position: relative;
  height: 52px;
  width: 52px;
  background-image: ${({ src, type }) =>
    `url(${getUrlWithFormat(src || '', type || '')})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`
export const ImageWrapper = styled.div<ProofImageProps>`
  position: relative;
  height: 52px;
  width: 52px;
  box-shadow: 0 0 30px -15px #000000;
  border-radius: 3px;
`

// DeleteButton component with optional icon prop
type DeleteButtonProps = {
  icon?: string
}

export const DeleteButton = styled.div<DeleteButtonProps>`
  height: 17px;
  width: 100%;
  background-image: ${`url(${
    process.env['BASE_URL'] ? `/${process.env['BASE_URL']}/static/` : '/'
  }icons/delete_icon.svg)`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
  transform-origin: 90%;
  transition-duration: 200ms; // Apply transition for normal state too
  transition-property: transform, filter; // Specify properties to transition
  &:hover {
    transform: scale(1.05);
    cursor: pointer;
    filter: invert(52%) sepia(13%) saturate(7096%) hue-rotate(331deg)
      brightness(86%) contrast(93%);
  }
`

export const DescText = styled(Text)`
  line-height: 28px;
`

export const ActionsWrapper = styled.div`
  display: flex;
  margin-top: 2rem;
  width: 100%;
  gap: 1rem;
  align-items: center;
  justify-content: end;
`
